import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken as saveToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setTokenState] = useState(getToken());
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const verify = async () => {
            if (!token) {
                setChecking(false);
                return;
            }
            try {
                await api.get("/auth/me");
            } catch {
                clearToken();
                setTokenState(null);
            }
            setChecking(false);
        };
        verify();
    }, [token]);

    const login = async (password) => {
        const res = await api.post("/auth/login", { password });
        saveToken(res.data.token);
        setTokenState(res.data.token);
    };

    const logout = () => {
        clearToken();
        setTokenState(null);
    };

    return (
        <AuthContext.Provider value={{ token, login, logout, checking }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
